import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText } from "mdbreact";
import piccspecial from "../../assets/calendar/calendarspecial.jpg";
import MetaTags from "react-meta-tags";

export default class Page2 extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (<>
            <MetaTags>
                <title>ปฏิทินการรับสมัคร ระดับปริญญาตรี ภาคกศ.บป. (เสาร์-อาทิตย์) มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
                <meta name="description" content="ปฏิทินการรับสมัคร ระดับปริญญาตรี ภาคกศ.บป. (เสาร์-อาทิตย์) มหาวิทยาลัยราชภัฏกำแพงเพชร Calendar's Kamphaeng Phet Rajabhat University" />
                <meta property="og:title" content="ปฏิทินการรับสมัคร ระดับปริญญาตรี ภาคกศ.บป. (เสาร์-อาทิตย์) มหาวิทยาลัยราชภัฏกำแพงเพชร" />
                <meta property="og:image" content="../../public/favicon.ico" />
            </MetaTags>
            <br />
            <MDBContainer fluid >
                <MDBRow>
                    <MDBCol lg="1" md="0" sm="0"></MDBCol>
                    <MDBCol lg="10" md="12" sm="12">
                        <MDBCard>
                            <MDBCardBody>
                                <MDBCardTitle>
                                    ปฏิทินการรับสมัคร ระดับปริญญาตรี ภาคกศ.บป. (เสาร์-อาทิตย์)
                                </MDBCardTitle>
                                <MDBCardText>
                                    <img style={{ margin: "0px 0px 10px 0px " }} src={piccspecial} width="100%" />
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg="1" md="0" sm="0"></MDBCol>
                </MDBRow>
            </MDBContainer>
        </>)
    }
}